// FIXME: JSのIntl.NumberFormatによる通貨表記機能(昔からある)
//  - CLIPサービスでの価格表記が統一されたらそれに合わせる。(それまではこのまま)

import Locale from "@/lib/locale";

export default new (class Price {
  getPrice(currencyCode: string, price: number) {
    try {
      // PAY-510 対応
      if (
        typeof Intl !== "undefined" &&
        typeof Intl.NumberFormat !== "undefined"
      ) {
        return Intl.NumberFormat(Locale.getLocale(), {
          style: "currency",
          currency: currencyCode
        }).format(Number(price));
      }

      return String(price + " " + currencyCode);
    } catch (e) {
      return String(price + " " + currencyCode);
    }
  }
})();
